module.exports = __webpack_public_path__ + "img/beijing.13df6235.jpg";